import { ServiceAgreement, ServiceAgreementFilterSettings, ServiceAgreementInformation } from '@model';
import { Action } from '@ngrx/store';

export enum ServiceAgreementsActionTypes {
    ServiceAgreementsLoad = '[ServiceAgreements] Load data',
    ServiceAgreementsLoadSuccess = '[ServiceAgreements] Load success',
    ServiceAgreementsLoadFail = '[ServiceAgreements] Load fail',
    ServiceAgreementsFilterSaveData = '[ServiceAgreements] Save filter',
    SelectServiceAgreement = '[ServiceAgreements] Select Service Agreement',
    SelectServiceAgreementById = '[ServiceAgreements] Select Service Agreement By Id',
    ServiceAgreementsSelectedPageIndex = '[ServiceAgreements] Set selected page index',
}

export class ServiceAgreementsLoad implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsLoad;
  constructor() {}
}

export class ServiceAgreementsLoadSuccess implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsLoadSuccess;
  constructor(public payload: ServiceAgreement[]) {}
}

export class ServiceAgreementsLoadFail implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsLoadFail;
  constructor(public payload: any) {}
}

// ServiceAgreements filter
export class ServiceAgreementsFilterSave implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsFilterSaveData;
  constructor(public payload: ServiceAgreementFilterSettings) {}
}

export class SelectServiceAgreement implements Action {
  readonly type = ServiceAgreementsActionTypes.SelectServiceAgreement;    
  constructor(public payload: ServiceAgreementInformation) {}
}

export class SelectServiceAgreementById implements Action {
  readonly type = ServiceAgreementsActionTypes.SelectServiceAgreementById;
  constructor(public payload: string) {}
}

export class ServiceAgreementsSelectedPageIndex implements Action {
  readonly type = ServiceAgreementsActionTypes.ServiceAgreementsSelectedPageIndex;
  constructor(
    public pageIndex: number,
    public pageSize: number,
    public sortColumn: string,
    public sortDirection: string,
    public scrollPosition: [number, number]
  ) {}
}

export type ServiceAgreementsActions =
  | ServiceAgreementsLoad
  | ServiceAgreementsLoadSuccess  
  | ServiceAgreementsLoadFail
  | ServiceAgreementsFilterSave
  | SelectServiceAgreement
  | SelectServiceAgreementById
  | ServiceAgreementsSelectedPageIndex;